"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
var ControlLoader = __importStar(require("../rcm/ControlManager"));
var RiskLoader = __importStar(require("../rcm/RiskManager"));
var StaffManager = __importStar(require("../rcm/StaffManager"));
var EvaluationUtils_1 = require("./EvaluationUtils");
function initTableContent() {
    return {
        headerRow: [],
        columnCountIncludeNumbering: 0,
        rowCountExceptHeader: 0,
        rowObjectList: []
    };
}
function getInitContent(id, isOperation) {
    return __awaiter(this, void 0, void 0, function () {
        var control, _a, _b, processCode, staff, risk, files, data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = (_a = Object).setPrototypeOf;
                    return [4 /*yield*/, ControlLoader.get(id)];
                case 1:
                    control = _b.apply(_a, [_c.sent(), Object.prototype]);
                    processCode = lodash_1.default.get(control, 'processCode');
                    return [4 /*yield*/, StaffManager.get(control.owner)];
                case 2:
                    staff = _c.sent();
                    return [4 /*yield*/, RiskLoader.get(control.riskNumber)];
                case 3:
                    risk = _c.sent();
                    files = {
                        record: {
                            type: BaseFile_1.FileType.Record,
                            evaluationType: isOperation ? Evaluation.Type.Operation : Evaluation.Type.Design,
                            name: '',
                            evaluationName: '',
                            controlId: id,
                            state: BaseFile_1.FileState.EMPTY,
                            file: undefined,
                            updateTime: '',
                            updater: '',
                            excelData: undefined,
                            checked: false
                        },
                        extra: {}
                    };
                    if (isOperation) {
                        files.population = {
                            type: BaseFile_1.FileType.Population,
                            evaluationType: Evaluation.Type.Operation,
                            name: '',
                            evaluationName: '',
                            controlId: id,
                            state: BaseFile_1.FileState.EMPTY,
                            file: undefined,
                            updater: '',
                            updateTime: '',
                            excelData: undefined,
                            checked: false
                        };
                        files.evidence = {};
                        data = {
                            type: Evaluation.Type.Operation,
                            updateTime: '',
                            createDate: '',
                            controlId: id,
                            resultState: Evaluation.ResultState.Default,
                            executor: '',
                            populationDescription: '',
                            populationCount: '',
                            populationCompleteness: '',
                            samplingMethod: '',
                            controlException: '',
                            samplingCount: 0,
                            populationTableColumnCount: 0,
                            samplingAttributeCount: 0,
                            samplingResult: initTableContent(),
                            attributeContents: initTableContent(),
                            testContents: initTableContent(),
                            validCount: '',
                            invalidCount: '',
                            testResult: ''
                        };
                    }
                    else {
                        data = {
                            type: Evaluation.Type.Design,
                            updateTime: '',
                            createDate: '',
                            controlId: id,
                            resultState: Evaluation.ResultState.Default,
                            ownerAssessment: '',
                            judgementLevel: Evaluation.JudgementLevel.low,
                            riskAssessmentBasis: '',
                            considerations: [],
                            baselineReference: '',
                            procedureContent: ''
                        };
                    }
                    return [2 /*return*/, {
                            processCode: processCode,
                            risk: risk,
                            control: control,
                            staff: staff,
                            files: files,
                            data: data
                        }];
            }
        });
    });
}
function getInitState(id, isOperation) {
    return __awaiter(this, void 0, void 0, function () {
        var control, weakState, weakStateData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ControlLoader.get(id)];
                case 1:
                    control = _a.sent();
                    weakState = isOperation
                        ? Evaluation.OperationWeakState.Default
                        : Evaluation.DesignWeakState.Default;
                    if (isOperation) {
                        weakStateData = {
                            1: {
                                question: '미비점으로 인한 재무제표 왜곡표시 발생가능성이 낮지 않은 경우인가?',
                                answer: '',
                                reason: ''
                            },
                            2: {
                                question: '잠재적인 왜곡표시의 규모가 재무제표에 미치는 영향이 중요한가',
                                answer: '',
                                reason: ''
                            },
                            3: {
                                question: '잠재적인 왜곡표시의 규모를 중요한 수준 미만으로 줄일 수 있는 보완통제가 있는가?',
                                answer: '',
                                reason: ''
                            },
                            4: {
                                question: '회계와 내부회계관리제도에 충분한 전문지식을 갖춘 관리자는 이 미비점을 중요한 취약점이라고 결론 내릴것으로 판단되는가?',
                                answer: '',
                                reason: ''
                            },
                            5: {
                                question: '미비점의 수준이 재무보고 관리감독기구(감사위원회 등)가 주목할 만큼 중요한가?',
                                answer: '',
                                reason: ''
                            }
                        };
                    }
                    else {
                        weakStateData = {
                            controlId: id,
                            control: {},
                            riskId: control.riskNumber,
                            risk: {}
                        };
                    }
                    return [2 /*return*/, {
                            approver: '',
                            owner: control.owner,
                            performer: control.incharge,
                            department: control.department,
                            accomplishTime: '',
                            approvalTime: '',
                            state: Evaluation.ProgressState.Unperformed,
                            resultState: Evaluation.ResultState.Default,
                            resultStateUpdateTime: '',
                            weakState: weakState,
                            weakStateData: weakStateData,
                            weakStateUpdateTime: ''
                        }];
            }
        });
    });
}
function createEvaluation(base) {
    return __awaiter(this, void 0, void 0, function () {
        var evaluationType, name, evaluationDoc, contentRef, stateRef;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    evaluationType = Evaluation.getKoEvaluation(base.type);
                    name = base.name.trim();
                    base.name = name;
                    base.period = Evaluation.getPeriod(base);
                    base.state = Evaluation.EvaluationState.Progress;
                    evaluationDoc = firebase.dbService.collection(evaluationType).doc(name);
                    return [4 /*yield*/, evaluationDoc.set(base)];
                case 1:
                    _a.sent();
                    contentRef = evaluationDoc.collection(EvaluationUtils_1.CONTENT_DOC_NAME);
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(base.controlIds, function (id) { return __awaiter(_this, void 0, void 0, function () {
                            var content;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, getInitContent(id, base.type === Evaluation.Type.Operation)];
                                    case 1:
                                        content = _a.sent();
                                        return [2 /*return*/, contentRef.doc(id).set(content)];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    stateRef = evaluationDoc.collection(EvaluationUtils_1.STATE_DOC_NAME);
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(base.controlIds, function (id) { return __awaiter(_this, void 0, void 0, function () {
                            var state;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, getInitState(id, base.type === Evaluation.Type.Operation)];
                                    case 1:
                                        state = _a.sent();
                                        return [2 /*return*/, stateRef.doc(id).set(state)];
                                }
                            });
                        }); }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function create(base) {
    return __awaiter(this, void 0, void 0, function () {
        var evaluationType, evaluationDoc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    evaluationType = Evaluation.getKoEvaluation(base.type);
                    return [4 /*yield*/, firebase.dbService
                            .collection(evaluationType)
                            .doc(base.name.trim())
                            .get()];
                case 1:
                    evaluationDoc = _a.sent();
                    if (evaluationDoc.exists) {
                        return [2 /*return*/, Promise.reject(new Error("\uC774\uBBF8 \uAC19\uC740 \uC885\uB958(".concat(base.type, "), \uAC19\uC740 \uC774\uB984(").concat(base.name, ") \uC758 \uD3C9\uAC00\uAC00 \uC788\uC2B5\uB2C8\uB2E4.")))];
                    }
                    return [4 /*yield*/, createEvaluation(base)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.create = create;
//# sourceMappingURL=EvaluationGenerator.js.map